// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dateInputComponent {
  position: relative;
  width: 100%;
}
.dateInputComponent input {
  background: #f3f5f6;
  border: none;
  padding: 8px;
}
.dateInputComponent .dateText {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  width: 115px;
}
.dateInputComponent .titleText {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.dateInputComponent .dateInputContainer {
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  width: 100%;
  height: 56px;
  padding: 16px;
  display: flex;
}
.dateInputComponent .calenderImage {
  margin-left: auto;
}
.dateInputComponent .disabledDateInputContainer {
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  width: 100%;
  height: 56px;
  display: flex;
}
.dateInputComponent .disabledDateInputContainer .dateInput {
  background: #f6f6f7;
  width: 70%;
  max-width: 237px;
  padding: 16px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-right: 1px solid #e9e9e9;
  display: flex;
}
.dateInputComponent .disabledDateInputContainer .dateInput .calenderImage {
  margin-left: auto;
}
.dateInputComponent .disabledDateInputContainer .hidden {
  background: #ffffff;
}
.dateInputComponent .disableButtonContainer {
  padding: 15px 22px;
  width: 120px;
}`, "",{"version":3,"sources":["webpack://./src/components/dateInput/DateInput.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;AACJ;AAAI;EACI,mBAAA;EACA,YAAA;EACA,YAAA;AAER;AAAI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AAER;AACI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACR;AAEI;EACI,mBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;AADR;AAGI;EACI,iBAAA;AADR;AAII;EACI,yBAAA;EACA,kBAAA;EAEA,WAAA;EACA,YAAA;EACA,aAAA;AAHR;AAIQ;EACI,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,8BAAA;EACA,+BAAA;EACA,aAAA;AAFZ;AAGY;EACI,iBAAA;AADhB;AAMQ;EACI,mBAAA;AAJZ;AAOI;EACI,kBAAA;EACA,YAAA;AALR","sourcesContent":[".dateInputComponent {\n    position: relative; \n    width: 100%;  \n    input {\n        background: #f3f5f6;\n        border: none;\n        padding: 8px;\n    }\n    .dateText {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;  \n        width: 115px; \n    }\n\n    .titleText {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n    }\n\n    .dateInputContainer {\n        background: #ffffff;\n        border: 1px solid #e9e9e9;\n        border-radius: 8px;\n        // width: 345px;\n        width:100%;\n        height: 56px;\n        padding: 16px;\n        display: flex;\n    }\n    .calenderImage {\n        margin-left: auto;\n    }\n\n    .disabledDateInputContainer {\n        border: 1px solid #e9e9e9;\n        border-radius: 8px;\n        // width: 345px;\n        width:100%;\n        height: 56px;\n        display: flex;\n        .dateInput {\n            background: #f6f6f7;\n            width:70%; \n            max-width: 237px;\n            padding: 16px;\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n            border-right: 1px solid #e9e9e9;\n            display: flex;\n            .calenderImage {\n                margin-left: auto;\n            }\n         \n        }\n\n        .hidden {\n            background: #ffffff;\n        }\n    }\n    .disableButtonContainer {\n        padding: 15px 22px;\n        width: 120px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
